import { render, staticRenderFns } from "./PaperSalesReturn.vue?vue&type=template&id=2db6fff9&scoped=true&"
import script from "./PaperSalesReturn.vue?vue&type=script&lang=js&"
export * from "./PaperSalesReturn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db6fff9",
  null
  
)

export default component.exports